import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../styles/NotFound.scss';

function NotFound() {
  // Flag the body so the navbar switches to its dark-on-light treatment — a 404's
  // arbitrary path has no header-<page> class of its own to key off.
  useEffect(() => {
    document.body.classList.add('notfound-active');
    return () => document.body.classList.remove('notfound-active');
  }, []);

  return (
    <div className="notfound">
      <Helmet>
        <title>Page Not Found | Lily Lai Real Estate</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="notfound-inner">
        <p className="notfound-eyebrow">404</p>
        <h1 className="notfound-title">This page doesn't exist</h1>
        <p className="notfound-text">
          The page you're looking for may have moved or never existed. Let's get you back on track.
        </p>
        <div className="notfound-links">
          <Link to="/" className="notfound-link">Home</Link>
          <Link to="/neighborhoods" className="notfound-link">Neighborhood Guides</Link>
          <Link to="/insights" className="notfound-link">Insights</Link>
          <Link to="/contact" className="notfound-link">Contact Lily</Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
